import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useResizeDetector } from 'react-resize-detector';
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import { Dialog as MDialog, DialogContent, IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import Preloader from '../../components/Preloader';
import Tooltip from '../../components/Tooltip';
import * as S from './Dialog.css';
const Dialog = ({ open, children, title, maxWidth, fullWidth, dialogActions, onClose, loadingContent = false, overflowInitial = false, classes, customMaxWidth, headerWidth = '100%', contentPadding = '1rem', headerControls, withoutCloseButton, leftDialogActions, wrapTitle, helpIconText, onKeyDown, disableEscapeKeyDown, onCtrlSSubmit, }) => {
    var _a;
    const { width: closeButtonWidth, ref: closeButtonRef } = useResizeDetector();
    const handleKeyDown = (event) => {
        let charCode = String.fromCharCode(event.which).toLowerCase();
        if ((event.ctrlKey || event.metaKey) && charCode === 's') {
            event.preventDefault();
            onCtrlSSubmit && onCtrlSSubmit();
        }
    };
    return (_jsx(MDialog, Object.assign({ open: open, maxWidth: maxWidth, fullWidth: fullWidth, onClose: onClose, classes: {
            paper: overflowInitial ? classes.dialogPaper : undefined,
            paperWidthMd: customMaxWidth ? classes.paperWidthMd : undefined,
        }, onKeyDown: (e) => {
            if (onKeyDown) {
                onKeyDown(e);
            }
            if (onCtrlSSubmit) {
                handleKeyDown(e);
            }
        }, disableEscapeKeyDown: disableEscapeKeyDown }, { children: loadingContent ? (_jsx(Preloader, {})) : (_jsxs(_Fragment, { children: [title && (_jsxs(S.Header, { children: [_jsxs(S.TitleWrapper, { children: [_jsx(Tooltip, Object.assign({ title: headerWidth !== '100%' ? title : '' }, { children: _jsx(S.HeaderTitle, Object.assign({ wraptitle: wrapTitle, headerwidth: headerWidth, closebuttonwidth: closeButtonWidth, variant: "h6" }, { children: title })) })), helpIconText && (_jsx(Tooltip, Object.assign({ title: helpIconText }, { children: _jsx("span", { children: _jsx(HelpIcon, { style: { color: 'silver' } }) }) })))] }), headerControls && _jsx("div", { children: headerControls }), !withoutCloseButton && (_jsx(IconButton, Object.assign({ onClick: onClose, ref: closeButtonRef }, { children: _jsx(CloseIcon, {}) })))] })), _jsx(DialogContent, Object.assign({ style: {
                        padding: contentPadding,
                        overflowY: overflowInitial ? 'initial' : undefined,
                    } }, { children: children })), (dialogActions || leftDialogActions) && (
                // hasleftdialogactions used to remove left margin for action on the left
                _jsxs(S.DialogActions, Object.assign({ hasleftdialogactions: (_a = Boolean(leftDialogActions)) === null || _a === void 0 ? void 0 : _a.toString() }, { children: [dialogActions, leftDialogActions && (_jsx(S.LeftDialogActionsWrapper, { children: leftDialogActions }))] })))] })) })));
};
const styles = {
    dialogPaper: {
        overflow: 'initial',
    },
    paperWidthMd: {
        maxWidth: '700px',
    },
};
export default withStyles(styles)(Dialog);
